import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { createStytchUIClient } from '@stytch/nextjs/ui';
import { AuthError, AuthErrorCodes } from './error';

var StytchClient = /*#__PURE__*/function () {
  function StytchClient(options) {
    var _options$redirectPath, _options$sessionDurat;

    _classCallCheck(this, StytchClient);

    _defineProperty(this, "client", void 0);

    _defineProperty(this, "redirectPath", void 0);

    _defineProperty(this, "sessionDurationMinutes", void 0);

    if (!options.apiKey) {
      throw new AuthError({
        message: 'An API key is required',
        code: AuthErrorCodes.MissingApiKey
      });
    }

    this.redirectPath = (_options$redirectPath = options.redirectPath) !== null && _options$redirectPath !== void 0 ? _options$redirectPath : '/authenticate';
    this.sessionDurationMinutes = (_options$sessionDurat = options.sessionDurationMinutes) !== null && _options$sessionDurat !== void 0 ? _options$sessionDurat : 60;
    if (typeof window === 'undefined') return;
    this.client = createStytchUIClient(options.apiKey);
  }

  _createClass(StytchClient, [{
    key: "getToken",
    value: function () {
      var _getToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _tokens;

        var tokens;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tokens = null;
                _context.prev = 1;
                tokens = this.client.session.getTokens();
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](1);
                throw new AuthError({
                  message: _context.t0.message,
                  code: AuthErrorCodes.InternalError
                });

              case 8:
                if (tokens) {
                  _context.next = 10;
                  break;
                }

                throw new AuthError({
                  message: 'User is not logged in',
                  code: AuthErrorCodes.Unauthorized
                });

              case 10:
                return _context.abrupt("return", (_tokens = tokens) === null || _tokens === void 0 ? void 0 : _tokens.session_token);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 5]]);
      }));

      function getToken() {
        return _getToken.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: "getUser",
    value: function getUser() {
      var _this$client;

      return (_this$client = this.client) === null || _this$client === void 0 ? void 0 : _this$client.user.get();
    }
  }, {
    key: "isLoggedIn",
    value: function isLoggedIn() {
      var _this$client2;

      return ((_this$client2 = this.client) === null || _this$client2 === void 0 ? void 0 : _this$client2.session.getSync()) !== null;
    }
  }, {
    key: "login",
    value: function login(_ref) {
      var _this$client3;

      var email = _ref.email;
      return (_this$client3 = this.client) === null || _this$client3 === void 0 ? void 0 : _this$client3.magicLinks.email.loginOrCreate(email, {
        login_magic_link_url: window.location.origin + this.redirectPath,
        signup_magic_link_url: window.location.origin + this.redirectPath
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      return this.client.session.revoke();
    }
  }, {
    key: "handleCallback",
    value: function () {
      var _handleCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var params, token, type, _resp, resp;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = new URLSearchParams(window.location.search);
                token = params.get('token');
                type = params.get('stytch_token_type');

                if (!(!token || !type)) {
                  _context2.next = 5;
                  break;
                }

                throw new AuthError({
                  message: 'In order to handleCallback, token and stytch_token_type must be in the query parameters',
                  code: AuthErrorCodes.Unauthorized
                });

              case 5:
                if (!(type === 'oauth')) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return this.client.oauth.authenticate(token, {
                  session_duration_minutes: this.sessionDurationMinutes
                });

              case 8:
                _resp = _context2.sent;
                return _context2.abrupt("return", _resp.session_token);

              case 10:
                _context2.next = 12;
                return this.client.magicLinks.authenticate(token, {
                  session_duration_minutes: this.sessionDurationMinutes
                });

              case 12:
                resp = _context2.sent;
                return _context2.abrupt("return", resp.session_token);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleCallback() {
        return _handleCallback.apply(this, arguments);
      }

      return handleCallback;
    }()
  }, {
    key: "getServiceClient",
    value: function getServiceClient() {
      return this.client;
    }
  }]);

  return StytchClient;
}();

export default StytchClient;